import { HeaderCellProps } from '../types';

export const TenantTypeHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <div>Tenant Type</div>;
};
